import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiClock, FiMapPin, FiTrash2, FiNavigation } = FiIcons;

const HistoryView = ({ history, onRemove, onSelectHistory, onNavigate }) => {
  if (history.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 px-8 text-center">
        <div className="w-20 h-20 bg-slate-50 rounded-[2.5rem] flex items-center justify-center mb-6">
          <SafeIcon icon={FiClock} className="text-3xl text-slate-200" />
        </div>
        <h4 className="font-black text-slate-950 text-xl tracking-tight mb-2">No Travel History</h4>
        <p className="text-slate-400 text-xs font-medium leading-relaxed max-w-[200px]">
          Your detected locations will appear here automatically for quick access.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6 px-2">
      <div className="flex items-center justify-between">
        <h3 className="text-xl font-black text-slate-950 tracking-tighter">
          Location <span className="text-indigo-600">History</span>
        </h3>
        <button
          onClick={() => onRemove('all')}
          className="text-[9px] font-black text-rose-600 uppercase tracking-widest bg-rose-50 px-3 py-1 rounded-full hover:bg-rose-100 transition-colors"
        >
          Clear All
        </button>
      </div>

      <div className="space-y-4">
        <AnimatePresence mode="popLayout">
          {history.map((item, idx) => {
            const flagUrl = item.countryCode ? `https://flagcdn.com/w40/${item.countryCode.toLowerCase()}.png` : null;
            return (
              <motion.div
                key={item.id || idx}
                layout
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.95 }}
                className="bg-white p-5 rounded-[2rem] border border-slate-100 high-contrast-shadow flex items-center gap-4 group"
              >
                <div
                  onClick={() => onSelectHistory(item)}
                  className="w-10 h-10 bg-slate-50 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-indigo-50 transition-all cursor-pointer overflow-hidden border border-slate-100"
                >
                  {flagUrl ? (
                    <img src={flagUrl} alt={item.countryCode} className="w-full h-full object-cover" />
                  ) : (
                    <SafeIcon icon={FiMapPin} className="text-sm text-slate-400" />
                  )}
                </div>

                <div className="flex-1 min-w-0 cursor-pointer" onClick={() => onSelectHistory(item)}>
                  <h5 className="font-black text-slate-950 text-sm truncate tracking-tight mb-0.5">
                    <span className="bg-indigo-50 px-1 rounded transition-colors group-hover:bg-indigo-100">
                      {item.address}
                    </span>
                  </h5>
                  <p className="text-[9px] font-bold text-slate-400 uppercase tracking-widest truncate">
                    {item.city || 'Unknown City'} • {new Date(item.timestamp).toLocaleDateString()}
                  </p>
                </div>

                <div className="flex gap-2">
                  <button
                    onClick={() => onNavigate(item.lat, item.lng)}
                    className="p-3 bg-slate-100 text-slate-600 rounded-xl hover:bg-slate-950 hover:text-white transition-all"
                  >
                    <SafeIcon icon={FiNavigation} className="text-xs" />
                  </button>
                  <button
                    onClick={() => onRemove(item.id)}
                    className="p-3 bg-white text-slate-300 rounded-xl hover:text-rose-600 transition-colors"
                  >
                    <SafeIcon icon={FiTrash2} className="text-xs" />
                  </button>
                </div>
              </motion.div>
            );
          })}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default HistoryView;